import Group from 'models/Group'

const getObject = (group) => new Group(group.name, group.description, group.photo, group.isPrivate)

export default getObject
